export const CLEAR_PROJECT_LIST = 'fulcrum/containers/ProjectSearchPage/CLEAR_PROJECT_LIST'
export const UPDATE_INPUT_VALUE = 'fulcrum/containers/ProjectSearchPage/UPDATE_INPUT_VALUE'
export const FETCH_PROJECT_LIST = 'fulcrum/containers/ProjectSearchPage/FETCH_PROJECT_LIST'

const listSortOrder = [
  'id',
  'name',
  'sku',
  'partnerSite',
  'partner',
  'odm',
  'lifecycle',
  'customerClass',
  'productClass',
  'projectType',
]

export const listOrder = Object.freeze(
  listSortOrder.reduce((result, category, index) => ({
    ...result,
    [category]: index
  }), {})
)

export const gridParams = {
  rowHeight: 48,
  overscanColumnCount: 0,
  overscanRowCount: 5,
}

export const leftGridParams = {
  columnCount: 1,
  columnWidth: 150,
}

export const headerGridParams = {
  rowCount: 1,
  rowHeight: 56,
}

export const cellMeasureCacheDefaults = {
  defaultWidth: 150,
  minWidth: 150,
  fixedHeight: true,
}
